/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _komponenteEditorEditor = __webpack_require__(20);
	
	var _generisanoScene = __webpack_require__(5);
	
	var editor = new _komponenteEditorEditor.Editor();
	var prvaScena = _generisanoScene.scene['1941-05-01-okupacija'];
	var trenutnaScena = prvaScena;
	
	trenutnaScena.start();
	
	/* DOGADJAJI */
	
	document.addEventListener("click", function (e) {
	  var element = e.target;
	  if (element.classList.contains('js-start')) pustiScenu(element.value);
	  if (element.classList.contains('js-reload')) window.location.reload();
	});
	
	document.addEventListener("dblclick", function (e) {
	  if (e.target.classList.contains('js-dvoklik-start')) pustiScenu(e.target.value);
	});
	
	window.addEventListener('load', rutiraj);
	window.addEventListener('hashchange', rutiraj);
	
	/* FUNKCIJE */
	
	function pustiScenu(ruta) {
	  trenutnaScena.stop();
	  if (ruta in _generisanoScene.scene) {
	    trenutnaScena = _generisanoScene.scene[ruta];
	  } else if (ruta == 'editor') {
	    trenutnaScena = editor;
	  } else {
	    trenutnaScena = prvaScena;
	  }
	  trenutnaScena.start();
	  window.location.hash = ruta;
	  window.scroll(0, 0);
	}
	
	function rutiraj() {
	  var ruta = window.location.hash.slice(1);
	  pustiScenu(ruta);
	}

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Scena2 = __webpack_require__(2);
	
	var _sablonHtml = __webpack_require__(34);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	var Izbor = (function (_Scena) {
	  _inherits(Izbor, _Scena);
	
	  function Izbor(podaci) {
	    _classCallCheck(this, Izbor);
	
	    _get(Object.getPrototypeOf(Izbor.prototype), 'constructor', this).call(this, podaci, _sablonHtml2['default']);
	    this.izbori = praviDugmice(podaci.izbori);
	  }
	
	  return Izbor;
	})(_Scena2.Scena);
	
	exports.Izbor = Izbor;
	
	function praviDugmice(izbori) {
	  var dugmici = '';
	  for (var n in izbori) {
	    dugmici += '<button value="' + izbori[n].link + '" class="js-start">' + izbori[n].opis + '</button>';
	  }
	  return dugmici;
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _igrac = __webpack_require__(19);
	
	/*
	 @param podaci: JSON object
	 @param sablon: HTML template
	 @param element: DOM element
	*/
	
	var Scena = (function () {
	  function Scena(podaci, sablon, element) {
	    _classCallCheck(this, Scena);
	
	    this.podaci = podaci || {};
	    this.sablon = sablon;
	    this.element = element || document.querySelector('#avantura');
	    this.igrac = _igrac.igrac;
	    this.podaciFajl = 'podaci.json';
	  }
	
	  _createClass(Scena, [{
	    key: 'start',
	    value: function start() {
	      this.render();
	      document.title = this.podaci.naslov || document.title;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.clear();
	    }
	  }, {
	    key: 'eval',
	    value: function _eval(sablon) {
	      return eval('`' + sablon + '`'); // convert string to template string
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var element = arguments.length <= 0 || arguments[0] === undefined ? this.element : arguments[0];
	      var sablon = arguments.length <= 1 || arguments[1] === undefined ? this.sablon : arguments[1];
	
	      element.innerHTML = this.eval(sablon);
	    }
	  }, {
	    key: 'dodaj',
	    value: function dodaj() {
	      var element = arguments.length <= 0 || arguments[0] === undefined ? this.element : arguments[0];
	      var sablon = arguments.length <= 1 || arguments[1] === undefined ? this.sablon : arguments[1];
	
	      element.innerHTML += this.eval(sablon);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.element.innerHTML = '';
	    }
	  }]);
	
	  return Scena;
	})();

	exports.Scena = Scena;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Scena2 = __webpack_require__(2);
	
	var _ishodZiv = __webpack_require__(22);
	
	var _ishodMrtav = __webpack_require__(21);
	
	var _sablonHtml = __webpack_require__(36);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	/*
	klasa Sudbina, za scene gde ishod zavisi od kockica
	@param podaci: json koji mapira sudbina/sablon.html
	@param ishodi: json koji mapira ishod/sablon.html, druga opcija je uvek smrt
	*/
	
	var Sudbina = (function (_Scena) {
	  _inherits(Sudbina, _Scena);
	
	  function Sudbina(podaci) {
	    _classCallCheck(this, Sudbina);
	
	    _get(Object.getPrototypeOf(Sudbina.prototype), "constructor", this).call(this, podaci, _sablonHtml2["default"]);
	    this.ishodi = this.praviIshodneScene(podaci.ishodi);
	  }
	
	  _createClass(Sudbina, [{
	    key: "start",
	    value: function start() {
	      _get(Object.getPrototypeOf(Sudbina.prototype), "start", this).call(this);
	      document.querySelector('#kockice').addEventListener('click', this.prikaziIshod.bind(this));
	    }
	  }, {
	    key: "praviIshodneScene",
	    value: function praviIshodneScene(ishodi) {
	      var ishodneScene = [];
	      for (var i = 0; i < ishodi.length; i++) {
	        ishodi[i].slika = ishodi[i].slika || this.podaci.slika;
	        var ishodnaScena = ishodi[i].mrtav ? new _ishodMrtav.Mrtav(ishodi[i]) : new _ishodZiv.Ziv(ishodi[i]);
	        ishodneScene.push(ishodnaScena);
	      }
	      return ishodneScene;
	    }
	  }, {
	    key: "prikaziIshod",
	    value: function prikaziIshod() {
	      var random = Math.floor(Math.random() * this.ishodi.length);
	      this.ishodi[random].start();
	    }
	  }]);
	
	  return Sudbina;
	})(_Scena2.Scena);

	exports.Sudbina = Sudbina;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _hronologija19410501OkupacijaJs = __webpack_require__(7);
	
	var _hronologija19410501OkupacijaJs2 = _interopRequireDefault(_hronologija19410501OkupacijaJs);
	
	var _hronologija19410510OdvodjenjeJs = __webpack_require__(8);
	
	var _hronologija19410510OdvodjenjeJs2 = _interopRequireDefault(_hronologija19410510OdvodjenjeJs);
	
	var _hronologija19410515RavnaGoraJs = __webpack_require__(9);
	
	var _hronologija19410515RavnaGoraJs2 = _interopRequireDefault(_hronologija19410515RavnaGoraJs);
	
	var _hronologija19410515PripremeJs = __webpack_require__(10);
	
	var _hronologija19410515PripremeJs2 = _interopRequireDefault(_hronologija19410515PripremeJs);
	
	var _hronologija19410707ZakletvaJs = __webpack_require__(11);
	
	var _hronologija19410707ZakletvaJs2 = _interopRequireDefault(_hronologija19410707ZakletvaJs);
	
	var _hronologija19410811IzvestajJs = __webpack_require__(12);
	
	var _hronologija19410811IzvestajJs2 = _interopRequireDefault(_hronologija19410811IzvestajJs);
	
	var _hronologija19410909DiverzijaJs = __webpack_require__(13);
	
	var _hronologija19410909DiverzijaJs2 = _interopRequireDefault(_hronologija19410909DiverzijaJs);
	
	var _hronologija19410924SabacJs = __webpack_require__(14);
	
	var _hronologija19410924SabacJs2 = _interopRequireDefault(_hronologija19410924SabacJs);
	
	var _hronologija19411010KraljevoJs = __webpack_require__(15);
	
	var _hronologija19411010KraljevoJs2 = _interopRequireDefault(_hronologija19411010KraljevoJs);
	
	var _hronologija19430315OpkoljenJs = __webpack_require__(16);
	
	var _hronologija19430315OpkoljenJs2 = _interopRequireDefault(_hronologija19430315OpkoljenJs);
	
	var _hronologija19440115OpkoljenJs = __webpack_require__(17);
	
	var _hronologija19440115OpkoljenJs2 = _interopRequireDefault(_hronologija19440115OpkoljenJs);
	
	var _hronologija19450101StrazaJs = __webpack_require__(18);
	
	var _hronologija19450101StrazaJs2 = _interopRequireDefault(_hronologija19450101StrazaJs);
	
	// nazivi su rute
	var scene = {
	  '1941-05-01-okupacija': new _hronologija19410501OkupacijaJs2['default'](),
	  '1941-05-10-odvodjenje': new _hronologija19410510OdvodjenjeJs2['default'](),
	  '1941-05-15-ravna-gora': new _hronologija19410515RavnaGoraJs2['default'](),
	  '1941-05-15-pripreme': new _hronologija19410515PripremeJs2['default'](),
	  '1941-07-07-zakletva': new _hronologija19410707ZakletvaJs2['default'](),
	  '1941-08-11-izvestaj': new _hronologija19410811IzvestajJs2['default'](),
	  '1941-09-09-diverzija': new _hronologija19410909DiverzijaJs2['default'](),
	  '1941-09-24-sabac': new _hronologija19410924SabacJs2['default'](),
	  '1941-10-10-kraljevo': new _hronologija19411010KraljevoJs2['default'](),
	  '1943-03-15-opkoljen': new _hronologija19430315OpkoljenJs2['default'](),
	  '1944-01-15-opkoljen': new _hronologija19440115OpkoljenJs2['default'](),
	  '1945-01-01-straza': new _hronologija19450101StrazaJs2['default']()
	};
	
	exports.scene = scene;
	var lokacije = {
	  '1941-05-01-okupacija': 'src/hronologija/1941/05-01/okupacija.js',
	  '1941-05-10-odvodjenje': 'src/hronologija/1941/05-10/odvodjenje.js',
	  '1941-05-15-ravna-gora': 'src/hronologija/1941/05-15/RavnaGora.js',
	  '1941-05-15-pripreme': 'src/hronologija/1941/05-15/pripreme.js',
	  '1941-07-07-zakletva': 'src/hronologija/1941/07-07/Zakletva.js',
	  '1941-08-11-izvestaj': 'src/hronologija/1941/08-11/Izvestaj.js',
	  '1941-09-09-diverzija': 'src/hronologija/1941/09-09/Diverzija.js',
	  '1941-09-24-sabac': 'src/hronologija/1941/09-24/Sabac.js',
	  '1941-10-10-kraljevo': 'src/hronologija/1941/10-10/Kraljevo.js',
	  '1943-03-15-opkoljen': 'src/hronologija/1943/03-15/Opkoljen.js',
	  '1944-01-15-opkoljen': 'src/hronologija/1944/01-15/Opkoljen.js',
	  '1945-01-01-straza': 'src/hronologija/1945/01-01/Straza.js'
	};
	exports.lokacije = lokacije;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Scena2 = __webpack_require__(2);
	
	var _sablonHtml = __webpack_require__(33);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	var odlaganjeDugmeta = 4000;
	var css = {
	  dugme: 'hidden'
	};
	
	var Ishod = (function (_Scena) {
	  _inherits(Ishod, _Scena);
	
	  function Ishod(podaci) {
	    _classCallCheck(this, Ishod);
	
	    _get(Object.getPrototypeOf(Ishod.prototype), 'constructor', this).call(this, podaci, _sablonHtml2['default']);
	    this.css = css;
	  }
	
	  _createClass(Ishod, [{
	    key: 'start',
	    value: function start() {
	      var _this = this;
	
	      _get(Object.getPrototypeOf(Ishod.prototype), 'start', this).call(this);
	      setTimeout(function () {
	        css.dugme = 'visible';
	        _this.render();
	      }, odlaganjeDugmeta);
	    }
	  }]);
	
	  return Ishod;
	})(_Scena2.Scena);

	exports.Ishod = Ishod;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _prirodaKishaJs = __webpack_require__(25);
	
	var _podaciJson = __webpack_require__(38);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var _stilCss = __webpack_require__(51);
	
	var _stilCss2 = _interopRequireDefault(_stilCss);
	
	var kisha = new _prirodaKishaJs.Kisha();
	
	var _default = (function (_Izbor) {
	  _inherits(_default, _Izbor);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	    this.stil = _stilCss2["default"];
	  }
	
	  _createClass(_default, [{
	    key: "start",
	    value: function start() {
	      _get(Object.getPrototypeOf(_default.prototype), "start", this).call(this);
	      kisha.start();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      _get(Object.getPrototypeOf(_default.prototype), "stop", this).call(this);
	      kisha.stop();
	    }
	  }]);

	  return _default;
	})(_komponenteIzborIzbor.Izbor);

	exports["default"] = _default;
	module.exports = exports["default"];

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteSudbinaSudbina = __webpack_require__(4);
	
	var _podaciJson = __webpack_require__(39);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var Odvodjenje = (function (_Sudbina) {
	  _inherits(Odvodjenje, _Sudbina);
	
	  function Odvodjenje() {
	    _classCallCheck(this, Odvodjenje);
	
	    _get(Object.getPrototypeOf(Odvodjenje.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return Odvodjenje;
	})(_komponenteSudbinaSudbina.Sudbina);
	
	exports["default"] = Odvodjenje;
	module.exports = exports["default"];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _ravnaGoraJson = __webpack_require__(41);
	
	var _ravnaGoraJson2 = _interopRequireDefault(_ravnaGoraJson);
	
	var _default = (function (_Izbor) {
	  _inherits(_default, _Izbor);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).call(this, _ravnaGoraJson2['default']);
	    this.podaciFajl = 'ravna-gora.json';
	  }
	
	  return _default;
	})(_komponenteIzborIzbor.Izbor);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _pripremeJson = __webpack_require__(40);
	
	var _pripremeJson2 = _interopRequireDefault(_pripremeJson);
	
	var _default = (function (_Izbor) {
	  _inherits(_default, _Izbor);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).call(this, _pripremeJson2['default']);
	    this.podaciFajl = 'pripreme.json';
	  }
	
	  return _default;
	})(_komponenteIzborIzbor.Izbor);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteZakletvaZakletva = __webpack_require__(24);
	
	var _podaciJson = __webpack_require__(42);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var PartizanskaZakletva = (function (_Zakletva) {
	  _inherits(PartizanskaZakletva, _Zakletva);
	
	  function PartizanskaZakletva() {
	    _classCallCheck(this, PartizanskaZakletva);
	
	    _get(Object.getPrototypeOf(PartizanskaZakletva.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return PartizanskaZakletva;
	})(_komponenteZakletvaZakletva.Zakletva);
	
	exports["default"] = PartizanskaZakletva;
	module.exports = exports["default"];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzvestajIzvestaj = __webpack_require__(23);
	
	var _podaciJson = __webpack_require__(43);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var NemackiIzvestaj = (function (_Izvestaj) {
	  _inherits(NemackiIzvestaj, _Izvestaj);
	
	  function NemackiIzvestaj() {
	    _classCallCheck(this, NemackiIzvestaj);
	
	    _get(Object.getPrototypeOf(NemackiIzvestaj.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return NemackiIzvestaj;
	})(_komponenteIzvestajIzvestaj.Izvestaj);
	
	exports["default"] = NemackiIzvestaj;
	module.exports = exports["default"];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _podaciJson = __webpack_require__(44);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var Diverzija = (function (_Izbor) {
	  _inherits(Diverzija, _Izbor);
	
	  function Diverzija() {
	    _classCallCheck(this, Diverzija);
	
	    _get(Object.getPrototypeOf(Diverzija.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return Diverzija;
	})(_komponenteIzborIzbor.Izbor);
	
	exports["default"] = Diverzija;
	module.exports = exports["default"];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteSudbinaSudbina = __webpack_require__(4);
	
	var _podaciJson = __webpack_require__(45);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var Sabac = (function (_Sudbina) {
	  _inherits(Sabac, _Sudbina);
	
	  function Sabac() {
	    _classCallCheck(this, Sabac);
	
	    _get(Object.getPrototypeOf(Sabac.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return Sabac;
	})(_komponenteSudbinaSudbina.Sudbina);
	
	exports["default"] = Sabac;
	module.exports = exports["default"];

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _podaciJson = __webpack_require__(46);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var OpsadaKraljeva = (function (_Izbor) {
	  _inherits(OpsadaKraljeva, _Izbor);
	
	  function OpsadaKraljeva() {
	    _classCallCheck(this, OpsadaKraljeva);
	
	    _get(Object.getPrototypeOf(OpsadaKraljeva.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return OpsadaKraljeva;
	})(_komponenteIzborIzbor.Izbor);
	
	exports["default"] = OpsadaKraljeva;
	module.exports = exports["default"];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteSudbinaSudbina = __webpack_require__(4);
	
	var _podaciJson = __webpack_require__(47);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var Opkoljen = (function (_Sudbina) {
	  _inherits(Opkoljen, _Sudbina);
	
	  function Opkoljen() {
	    _classCallCheck(this, Opkoljen);
	
	    _get(Object.getPrototypeOf(Opkoljen.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return Opkoljen;
	})(_komponenteSudbinaSudbina.Sudbina);
	
	exports["default"] = Opkoljen;
	module.exports = exports["default"];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _podaciJson = __webpack_require__(48);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var Opkoljen = (function (_Izbor) {
	  _inherits(Opkoljen, _Izbor);
	
	  function Opkoljen() {
	    _classCallCheck(this, Opkoljen);
	
	    _get(Object.getPrototypeOf(Opkoljen.prototype), "constructor", this).call(this, _podaciJson2["default"]);
	  }
	
	  return Opkoljen;
	})(_komponenteIzborIzbor.Izbor);
	
	exports["default"] = Opkoljen;
	module.exports = exports["default"];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteIzborIzbor = __webpack_require__(1);
	
	var _podaciJson = __webpack_require__(49);
	
	var _podaciJson2 = _interopRequireDefault(_podaciJson);
	
	var _prirodaSnegJs = __webpack_require__(26);
	
	var _prirodaSnegJs2 = _interopRequireDefault(_prirodaSnegJs);
	
	var sneg = new _prirodaSnegJs2['default']();
	
	var _default = (function (_Izbor) {
	  _inherits(_default, _Izbor);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).call(this, _podaciJson2['default']);
	  }
	
	  _createClass(_default, [{
	    key: 'start',
	    value: function start() {
	      _get(Object.getPrototypeOf(_default.prototype), 'start', this).call(this);
	      sneg.start();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      _get(Object.getPrototypeOf(_default.prototype), 'stop', this).call(this);
	      sneg.stop();
	    }
	  }]);

	  return _default;
	})(_komponenteIzborIzbor.Izbor);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var igrac = {
	  ime: null,
	  jedinica: 'Valjevski partizanski odred',
	  pol: null,
	  strana: null,
	  bitke: [],
	  poena: 0,
	  ubioNemaca: 0,
	  ubioItalijana: 0,
	  ubioUstasa: 0,
	  ubioChetnika: 0,
	  ubioPartizana: 0,
	  ubioCivila: 0,
	  poginuo: 0,
	  odlikovanja: []
	};
	exports.igrac = igrac;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// da linije budu vucljive
	// da pratiMisha menja x2 i y2 umesto style.left i style.top
	// kada izbor dodirne scenu da preuzme vrednost (zalepi se)
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Scena2 = __webpack_require__(2);
	
	var _generisanoScene = __webpack_require__(5);
	
	var _pozicijeJson = __webpack_require__(50);
	
	var _pozicijeJson2 = _interopRequireDefault(_pozicijeJson);
	
	var _sablonHtml = __webpack_require__(32);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	var _stilCss = __webpack_require__(52);
	
	var _stilCss2 = _interopRequireDefault(_stilCss);
	
	var startY = 0;
	var proredY = 200;
	
	var Editor = (function (_Scena) {
	  _inherits(Editor, _Scena);
	
	  function Editor() {
	    _classCallCheck(this, Editor);
	
	    _get(Object.getPrototypeOf(Editor.prototype), 'constructor', this).call(this, {}, _sablonHtml2['default']);
	    this.stil = _stilCss2['default'];
	    this.svgVisina = 0;
	    this.praviGraf();
	  }
	
	  _createClass(Editor, [{
	    key: 'start',
	    value: function start() {
	      _get(Object.getPrototypeOf(Editor.prototype), 'start', this).call(this);
	      this.azurirajPozicije();
	      this.dodajSlusace();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      _get(Object.getPrototypeOf(Editor.prototype), 'stop', this).call(this);
	      this.ukloniSlusace();
	    }
	  }, {
	    key: 'praviGraf',
	    value: function praviGraf() {
	      this.datumi = '';
	      this.scene = '';
	      this.putanje = '';
	      var y = startY;
	      var prethodniDatum = null;
	      var prethodnaGodina = null;
	      var polaSirineDugmeta = 150; // zakucano, dugme jos nije renderovano
	      var polaVisineDugmeta = 44;
	      var polaSirineInputa = 118;
	      var polaVisineInputa = 22;
	
	      for (var scena in _generisanoScene.scene) {
	        var x = _pozicijeJson2['default'][scena] && _pozicijeJson2['default'][scena].x || window.innerWidth / 2 - polaSirineDugmeta;
	        var godina = scena.substring(0, 4);
	        var datum = scena.substring(0, 10);
	        if (prethodniDatum && datum != prethodniDatum) y += proredY; // pravi novi red samo za novi datum
	
	        if (godina != prethodnaGodina) {
	          this.datumi += '<h1 class="datum absolute" style="top:' + y + 'px;">' + godina + '</h1>';
	          y += 100;
	        }
	
	        if (datum != prethodniDatum) {
	          this.datumi += '<strong class="datum absolute" style="top:' + y + 'px;">' + datum + '</strong>';
	        }
	
	        this.scene += '\n        <button value="' + scena + '" class="dugme-scena js-mrda-x js-dvoklik-start absolute"\n        style="top:' + y + 'px; left:' + x + 'px;" contenteditable="true">\n          ' + _generisanoScene.scene[scena].podaci.naslov + '<br>\n          ' + scena + '\n        </button>';
	
	        if (_generisanoScene.scene[scena].podaci.izbori) {
	          var izbori = _generisanoScene.scene[scena].podaci.izbori;
	          for (var i = 0; i < izbori.length; i++) {
	            this.putanje += '\n            <line\n              x1="' + (x + polaSirineDugmeta) + '"\n              y1="' + (y + polaVisineDugmeta) + '" ';
	            // ako ima pozicija scene, povezuje putanjom, ako nema pravi input
	            if (_pozicijeJson2['default'][izbori[i].link]) {
	              var ishodX = _pozicijeJson2['default'][izbori[i].link].x;
	              var ishodY = _pozicijeJson2['default'][izbori[i].link].y;
	              this.putanje += '\n              x2="' + (ishodX + polaSirineDugmeta) + '"\n              y2="' + (ishodY + polaVisineDugmeta) + '" />';
	            } else {
	              var inputX = x + i * 300 - polaSirineDugmeta;
	              var inputY = y + 130;
	              this.scene += '\n              <input\n                class="js-azurira-izbor js-mrda-x js-mrda-y absolute"\n                style="top:' + inputY + 'px; left:' + inputX + 'px;"\n                value="' + izbori[i].link + '"\n                data-scena="' + scena + '" data-index="' + i + '" />\n              <small\n                class="absolute"\n                style="top:' + inputY + 'px; left:' + inputX + 'px;">\n                ' + izbori[i].opis + '\n              </small>\n            ';
	              this.putanje += '\n              x2="' + (inputX + polaSirineInputa) + '"\n              y2="' + (inputY + polaVisineInputa) + '" />';
	            }
	          }
	        }
	        this.svgVisina = y > this.svgVisina ? y : this.svgVisina;
	
	        prethodnaGodina = godina;
	        prethodniDatum = datum;
	      }
	    }
	  }, {
	    key: 'azurirajPolozaj',
	    value: function azurirajPolozaj(e) {
	      var element = e.target;
	      if (!_pozicijeJson2['default'][element.value]) return;
	      if (_pozicijeJson2['default'][element.value].x == parseInt(element.style.left)) return;
	      _pozicijeJson2['default'][element.value].x = parseInt(element.style.left);
	      this.render();
	    }
	  }, {
	    key: 'azurirajIzbor',
	    value: function azurirajIzbor(element) {
	      var ishod = element.value;
	      var lokacija = _generisanoScene.lokacije[element.dataset.scena];
	      var index = element.dataset.index;
	      var fajl = _generisanoScene.scene[element.dataset.scena].podaciFajl;
	      var http = new XMLHttpRequest();
	      http.onload = function () {
	        return console.log(http.responseText);
	      };
	      http.open("POST", "http://localhost:3000/podaci", true);
	      http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	      http.send('ishod=' + ishod + '&lokacija=' + lokacija + '&index=' + index + '&fajl=' + fajl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.praviGraf();
	      _get(Object.getPrototypeOf(Editor.prototype), 'render', this).call(this);
	    }
	  }, {
	    key: 'azurirajPozicije',
	    value: function azurirajPozicije() {
	      var pozicije = JSON.stringify(this.dajPozicije());
	      var http = new XMLHttpRequest();
	      http.onload = function () {
	        return console.log(http.responseText);
	      };
	      http.open("POST", "http://localhost:3000/pozicije", true);
	      http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	      http.send('pozicije=' + pozicije);
	    }
	  }, {
	    key: 'dajPozicije',
	    value: function dajPozicije() {
	      var scene = document.querySelectorAll('.dugme-scena');
	      var pozicije = {};
	      for (var i = 0; i < scene.length; i++) {
	        var dugme = scene[i];
	        pozicije[dugme.value] = {};
	        pozicije[dugme.value].x = parseInt(dugme.style.left);
	        pozicije[dugme.value].y = parseInt(dugme.style.top);
	      }
	      return pozicije;
	    }
	  }, {
	    key: 'pocniVucenje',
	    value: function pocniVucenje(e) {
	      e.target.draggable = true;
	    }
	  }, {
	    key: 'pratiMisha',
	    value: function pratiMisha(e) {
	      var element = e.target;
	      if (element.classList && element.classList.contains('js-mrda-x')) element.style.left = e.pageX - element.clientWidth / 2 + 'px';
	      if (element.classList && element.classList.contains('js-mrda-y')) element.style.top = e.pageY - element.clientHeight / 2 + 'px';
	    }
	  }, {
	    key: 'zavrsiVucenje',
	    value: function zavrsiVucenje(e) {
	      e.target.draggable = false;
	      this.azurirajPolozaj(e);
	    }
	
	    /*** DOGADJAJI ***/
	
	  }, {
	    key: 'dodajSlusace',
	    value: function dodajSlusace() {
	      document.addEventListener("mousedown", this.obradiMishStisnut.bind(this));
	      document.addEventListener("mouseup", this.obradiMishPushten.bind(this));
	      document.addEventListener("mouseout", this.obradiMishIzvan.bind(this));
	      document.addEventListener("mousemove", this.obradiMishMrda.bind(this));
	      document.addEventListener("click", this.obradiKlik.bind(this));
	      document.addEventListener("dblclick", this.obradiDvoklik.bind(this));
	    }
	  }, {
	    key: 'ukloniSlusace',
	    value: function ukloniSlusace() {
	      document.removeEventListener("mousedown", this.obradiMishStisnut);
	      document.removeEventListener("mouseup", this.obradiMishPushten);
	      document.removeEventListener("mouseout", this.obradiMishIzvan);
	      document.removeEventListener("mousemove", this.obradiMishMrda);
	      document.removeEventListener("click", this.obradiKlik);
	      document.removeEventListener("dblclick", this.obradiDvoklik);
	    }
	  }, {
	    key: 'obradiMishStisnut',
	    value: function obradiMishStisnut(e) {
	      if (e.target.classList.contains('js-mrda-x')) this.pocniVucenje(e);
	    }
	  }, {
	    key: 'obradiMishPushten',
	    value: function obradiMishPushten(e) {
	      if (e.target.classList.contains('js-mrda-x')) this.zavrsiVucenje(e);
	    }
	  }, {
	    key: 'obradiMishIzvan',
	    value: function obradiMishIzvan(e) {
	      if (e.target.classList.contains('js-mrda-x')) this.zavrsiVucenje(e);
	    }
	  }, {
	    key: 'obradiMishMrda',
	    value: function obradiMishMrda(e) {
	      if (e.target.draggable) this.pratiMisha(e);
	    }
	  }, {
	    key: 'obradiKlik',
	    value: function obradiKlik(e) {
	      if (e.target.id == 'sacuvaj') this.azurirajPozicije();
	    }
	  }, {
	    key: 'obradiDvoklik',
	    value: function obradiDvoklik(e) {
	      var element = e.target;
	      if (element.classList && element.classList.contains('js-azurira-izbor')) this.azurirajIzbor(element);
	    }
	  }]);
	
	  return Editor;
	})(_Scena2.Scena);

	exports.Editor = Editor;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Ishod2 = __webpack_require__(6);
	
	var _stilMrtavCss = __webpack_require__(53);
	
	var _stilMrtavCss2 = _interopRequireDefault(_stilMrtavCss);
	
	var akcije = ['Pokušaj ponovo!', 'Pokušaj opet', 'Probaj iznova', 'Okušaj se još jednom'];
	var ishodi = ['Hrabro si pao u borbi protiv okupatora. Tvoje telo će pojesti crvi, ali sećanje na tvoju borbu trajaće večno.', 'Ubijen si u borbi sa jačim. Tvoje kosti sada raznose zveri, ali tvoja hrabrost nadahnjuje generacije.', 'Ubijen si od dušmanske ruke. Tvoj grob će ostati neznan, ali tvoji su podvizi proslavljeni pesmom.'];
	
	var Mrtav = (function (_Ishod) {
	  _inherits(Mrtav, _Ishod);
	
	  function Mrtav(podaci) {
	    _classCallCheck(this, Mrtav);
	
	    _get(Object.getPrototypeOf(Mrtav.prototype), 'constructor', this).call(this, podaci);
	    this.stil = _stilMrtavCss2['default'];
	    this.podaci.naslov = podaci.naslov || 'Mrtav si';
	    this.podaci.slika = podaci.slika || 'fotke/smrt/jajinci-doubijanje.jpg';
	    this.podaci.opis = podaci.opis || ishodi[Math.floor(Math.random() * ishodi.length)];
	    this.podaci.akcija = podaci.akcija || akcije[Math.floor(Math.random() * akcije.length)];
	    this.podaci.link = podaci.link || '';
	  }
	
	  return Mrtav;
	})(_Ishod2.Ishod);

	exports.Mrtav = Mrtav;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Ishod2 = __webpack_require__(6);
	
	var akcije = ['Nastavi', 'Dalje', 'Nastavi borbu', 'Hrabro napred'];
	
	var Ziv = (function (_Ishod) {
	  _inherits(Ziv, _Ishod);
	
	  function Ziv(podaci) {
	    _classCallCheck(this, Ziv);
	
	    _get(Object.getPrototypeOf(Ziv.prototype), 'constructor', this).call(this, podaci);
	    this.podaci.akcija = podaci.akcija || akcije[Math.floor(Math.random() * akcije.length)];
	  }
	
	  return Ziv;
	})(_Ishod2.Ishod);

	exports.Ziv = Ziv;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Scena2 = __webpack_require__(2);
	
	var _sablonHtml = __webpack_require__(35);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	var _stilCss = __webpack_require__(54);
	
	var _stilCss2 = _interopRequireDefault(_stilCss);
	
	var _pozadinaJpg = __webpack_require__(31);
	
	var _pozadinaJpg2 = _interopRequireDefault(_pozadinaJpg);
	
	var brojacTeksta = 0;
	var brojacPotpisa = 0;
	var kuckanjeInterval;
	
	var Izvestaj = (function (_Scena) {
	  _inherits(Izvestaj, _Scena);
	
	  function Izvestaj(podaci) {
	    _classCallCheck(this, Izvestaj);
	
	    _get(Object.getPrototypeOf(Izvestaj.prototype), "constructor", this).call(this, podaci, _sablonHtml2["default"]);
	    this.stil = _stilCss2["default"];
	    this.zvuk = new Audio(__dirname + 'zvuci/kuckanje.mp3');
	  }
	
	  _createClass(Izvestaj, [{
	    key: "start",
	    value: function start() {
	      var _this = this;
	
	      _get(Object.getPrototypeOf(Izvestaj.prototype), "start", this).call(this);
	      this.elementTekst = document.querySelector('#tekst');
	      this.elementPotpis = document.querySelector('#potpis');
	      this.privremenaSlika = new Image(); // backgroundImage nema onload
	      this.privremenaSlika.onload = function () {
	        document.querySelector('#izvestaj-pozadina').style.backgroundImage = "url(" + _pozadinaJpg2["default"] + ")";
	        kuckanjeInterval = window.setInterval(_this.kucaj.bind(_this), 80);
	        _this.zvuk.play();
	        delete _this.privremenaSlika;
	      };
	      this.privremenaSlika.src = _pozadinaJpg2["default"];
	    }
	  }, {
	    key: "kucaj",
	    value: function kucaj() {
	      this.elementTekst.innerHTML += this.podaci.tekst.charAt(brojacTeksta);
	      brojacTeksta++;
	      if (brojacTeksta > this.podaci.tekst.length) {
	        this.elementPotpis.innerHTML += this.podaci.potpis.charAt(brojacPotpisa);
	        brojacPotpisa++;
	      }
	      if (brojacPotpisa >= this.podaci.potpis.length) {
	        this.zvuk.pause();
	        clearInterval(kuckanjeInterval);
	      }
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      _get(Object.getPrototypeOf(Izvestaj.prototype), "stop", this).call(this);
	      brojacTeksta = 0;
	      brojacPotpisa = 0;
	    }
	  }]);
	
	  return Izvestaj;
	})(_Scena2.Scena);

	exports.Izvestaj = Izvestaj;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _komponenteScena = __webpack_require__(2);
	
	var _sablonHtml = __webpack_require__(37);
	
	var _sablonHtml2 = _interopRequireDefault(_sablonHtml);
	
	var css = {
	  upute: '',
	  zakletva: "none"
	};
	
	var Zakletva = (function (_Scena) {
	  _inherits(Zakletva, _Scena);
	
	  function Zakletva(podaci) {
	    _classCallCheck(this, Zakletva);
	
	    _get(Object.getPrototypeOf(Zakletva.prototype), "constructor", this).call(this, podaci, _sablonHtml2["default"]);
	    this.css = css;
	  }
	
	  _createClass(Zakletva, [{
	    key: "start",
	    value: function start() {
	      _get(Object.getPrototypeOf(Zakletva.prototype), "start", this).call(this);
	      document.querySelector("#ime").focus();
	      document.querySelector('#pokazi-zakletvu').addEventListener('click', this.pokaziZakletvu.bind(this));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.element.innerHTML = this.eval(this.eval(this.sablon)); // evaluira dvaput, za sablone unutar sablona
	    }
	  }, {
	    key: "pokaziZakletvu",
	    value: function pokaziZakletvu() {
	      this.igrac.ime = document.querySelector("#ime").value;
	      if (!this.igrac.ime) return;
	      this.css.zakletva = 'block';
	      this.css.upute = 'none';
	      this.render();
	    }
	  }]);
	
	  return Zakletva;
	})(_komponenteScena.Scena);

	exports.Zakletva = Zakletva;

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ukupnoKapi = 40;
	var snagaVetra = 2;
	var srednjiPomak = 8;
	var srednjaVelicinaKapi = 8;
	var boje = ["#555555", "#888888", "#666666", "#999999", "#777777", "#aaaaaa"];
	
	var innerWidth = window.innerWidth;
	var innerHeight = window.innerHeight;
	var pageXOffset = window.pageXOffset;
	var pageYOffset = window.pageYOffset;
	
	var Kap = (function () {
	  function Kap(x, y, velicina, boja, pomak, vetar) {
	    _classCallCheck(this, Kap);
	
	    this.x = x;
	    this.y = y;
	    this.pomak = pomak;
	    this.vetar = vetar;
	    this.element = document.createElement('div');
	    this.element.style.height = velicina + "px";
	    this.element.style.background = "" + boja;
	    this.element.style.position = 'absolute';
	    this.element.style.width = '1px';
	    this.element.style.visibility = 'hidden';
	    this.element.style.top = 0;
	    this.element.style.left = 0;
	  }
	
	  _createClass(Kap, [{
	    key: "update",
	    value: function update() {
	      this.y += this.pomak;
	      this.x += this.vetar;
	      this.x = (this.x + innerWidth) % innerWidth; // drzi u granicama ekrana
	      this.element.style.left = this.x + pageXOffset + 'px';
	      this.element.style.top = this.y + pageYOffset + 'px';
	    }
	  }, {
	    key: "dodaj",
	    value: function dodaj() {
	      document.body.appendChild(this.element);
	    }
	  }, {
	    key: "ukloni",
	    value: function ukloni() {
	      document.body.removeChild(this.element);
	    }
	  }]);
	
	  return Kap;
	})();
	
	var Kisha = (function () {
	  function Kisha() {
	    _classCallCheck(this, Kisha);
	  }
	
	  _createClass(Kisha, [{
	    key: "start",
	    value: function start() {
	      this.kapi = [];
	      this.vetar = Math.random() < 0.5 ? snagaVetra : -snagaVetra;
	      this.brojKapi = ukupnoKapi;
	      this.trenutnoKapi = 0;
	      this.praviKapi();
	      this.interval = window.setInterval(this.update.bind(this), 20);
	      document.body.style.overflowY = 'scroll';
	      document.body.style.overflowX = 'hidden';
	    }
	  }, {
	    key: "praviKapi",
	    value: function praviKapi() {
	      for (var i = 0; i < this.brojKapi; i++) {
	        var kapX = Math.round(Math.random() * innerWidth);
	        var kapY = Math.round(Math.random() * innerHeight);
	        var velicina = Math.round(Math.random() * srednjaVelicinaKapi) + srednjaVelicinaKapi;
	        var boja = boje[i % 6];
	        var pomak = Math.round(Math.random() * 8) + srednjiPomak;
	        var kap = new Kap(kapX, kapY, velicina, boja, pomak, this.vetar);
	        kap.dodaj();
	        this.kapi.push(kap);
	      }
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      azurirajOfset();
	      if (this.trenutnoKapi < this.brojKapi) this.laganoKreni();
	      for (var i = 0; i < this.trenutnoKapi; i++) {
	        this.kapi[i].update();
	        if (this.kapi[i].y >= innerHeight) this.kapi[i].y = -10;
	      }
	    }
	  }, {
	    key: "laganoKreni",
	    value: function laganoKreni() {
	      this.trenutnoKapi++;
	      this.kapi[this.trenutnoKapi - 1].element.style.visibility = 'visible';
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.brojKapi = 0;
	      clearInterval(this.interval);
	      this.kapi.map(function (kap) {
	        return kap.ukloni();
	      });
	      document.body.removeAttribute('style');
	    }
	  }]);
	
	  return Kisha;
	})();
	
	exports.Kisha = Kisha;
	
	function azurirajOfset() {
	  pageXOffset = window.pageXOffset;
	  pageYOffset = window.pageYOffset;
	}

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * https://github.com/scottschiller/snowstorm/
	 * Making it snow on the internets since 2003. You're welcome.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var snowColor = '#fff';
	var snowCharacter = '&bull;'; // &bull; = bullet, &middot; is square on some systems etc.
	var flakeWidth = 8; // Max pixel width reserved for snow element
	var flakeHeight = 8; // Max pixel height reserved for snow element
	var zIndex = 0; // CSS stacking order applied to each snowflake
	var meltFrameCount = 20;
	var meltFrames = [];
	
	var screenX = null,
	    halfScreenX = null,
	    screenY = null,
	    scrollY = null,
	    docHeight = null,
	    vRndX = null,
	    vRndY = null,
	    windOffset = 1,
	    windMultiplier = 2,
	    flakeTypes = 6;
	
	var SnowFlake = (function () {
	  function SnowFlake(snowstorm, type) {
	    _classCallCheck(this, SnowFlake);
	
	    this.snowstorm = snowstorm;
	    this.type = type;
	    this.x = random(screenX - 20);
	    this.y = -random(screenY) - 12;
	    this.snowStick = true; // Whether or not snow should "stick" at the bottom
	    this.useMeltEffect = true; // When recycling fallen snow (or rarely, when falling), have it "melt" and fade out
	    this.vX = null;
	    this.vY = null;
	    this.vAmpTypes = [1, 1.2, 1.4, 1.6, 1.8]; // "amplification" for vX/vY (based on flake size/type)
	    this.vAmp = this.vAmpTypes[this.type] || 1;
	    this.melting = false;
	    this.meltFrame = 0;
	    this.active = 1;
	    this.fontSize = 10 + this.type / 5 * 10;
	    this.element = document.createElement('div');
	    this.element.innerHTML = snowCharacter;
	    this.element.style.color = snowColor;
	    this.element.style.height = flakeHeight + 'px';
	    this.element.style.position = 'absolute';
	    this.element.style.width = flakeWidth + 'px';
	    this.element.style.zIndex = zIndex;
	    document.body.appendChild(this.element);
	    this.recycle();
	  }
	
	  _createClass(SnowFlake, [{
	    key: 'stick',
	    value: function stick() {
	      this.element.style.bottom = '0%';
	      this.element.style.position = 'fixed';
	      this.element.style.top = 'auto';
	    }
	  }, {
	    key: 'vCheck',
	    value: function vCheck() {
	      if (this.vX >= 0 && this.vX < 0.2) {
	        this.vX = 0.2;
	      } else if (this.vX < 0 && this.vX > -0.2) {
	        this.vX = -0.2;
	      }
	      if (this.vY >= 0 && this.vY < 0.2) {
	        this.vY = 0.2;
	      }
	    }
	  }, {
	    key: 'move',
	    value: function move() {
	      var vX = this.vX * windOffset;
	      var yDiff = undefined;
	      this.x += vX;
	      this.y += this.vY * this.vAmp;
	      if (this.x >= screenX || screenX - this.x < flakeWidth) {
	        // X-axis scroll check
	        this.x = 0;
	      } else if (vX < 0 && this.x < -flakeWidth) {
	        this.x = screenX - flakeWidth - 1; // flakeWidth;
	      }
	      this.updatePosition();
	      yDiff = screenY + scrollY - this.y + flakeHeight;
	      if (yDiff < flakeHeight) {
	        this.active = 0;
	        if (this.snowStick) {
	          this.stick();
	        } else {
	          this.recycle();
	        }
	      } else {
	        if (this.useMeltEffect && this.active && this.type < 3 && !this.melting && Math.random() > 0.998) {
	          // ~1/1000 chance of melting mid-air, with each frame
	          this.melting = true;
	          this.melt();
	        }
	      }
	    }
	  }, {
	    key: 'setVelocities',
	    value: function setVelocities() {
	      this.vX = vRndX + random(this.snowstorm.vMaxX * 0.12, 0.1);
	      this.vY = vRndY + random(this.snowstorm.vMaxY * 0.12, 0.1);
	    }
	  }, {
	    key: 'setOpacity',
	    value: function setOpacity(element, opacity) {
	      element.style.opacity = opacity;
	    }
	  }, {
	    key: 'melt',
	    value: function melt() {
	      if (this.meltFrame < meltFrameCount) {
	        this.element.style.fontSize = this.fontSize - this.fontSize * (this.meltFrame / meltFrameCount) + 'px';
	        this.element.style.lineHeight = flakeHeight + 2 + flakeHeight * 0.75 * (this.meltFrame / meltFrameCount) + 'px';
	        this.element.style.opacity = meltFrames[this.meltFrame];
	        this.meltFrame++;
	      } else {
	        this.recycle();
	      }
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      this.element.style.right = 100 - this.x / screenX * 100 + '%';
	      this.element.style.bottom = 100 - this.y / screenY * 100 + '%';
	    }
	  }, {
	    key: 'recycle',
	    value: function recycle() {
	      this.setVelocities();
	      this.vCheck();
	      this.meltFrame = 0;
	      this.melting = false;
	      this.element.style.bottom = 'auto';
	      this.element.style.fontSize = this.fontSize + 'px';
	      this.element.style.lineHeight = flakeHeight + 2 + 'px';
	      this.element.style.margin = '0px';
	      this.element.style.opacity = 1;
	      this.element.style.padding = '0px';
	      this.element.style.position = 'absolute';
	      this.element.style.textAlign = 'center';
	      this.element.style.verticalAlign = 'baseline';
	      this.x = random(screenX - flakeWidth - 20);
	      this.y = random(screenY) * -1 - flakeHeight;
	      this.updatePosition();
	      this.active = 1;
	    }
	  }]);
	
	  return SnowFlake;
	})();
	
	var Snowstorm = (function () {
	  function Snowstorm() {
	    _classCallCheck(this, Snowstorm);
	
	    this.flakesMax = 128; // total amount of snow made (falling + sticking)
	    this.flakesMaxActive = 64; // amount of snow falling at once (less = lower CPU use)
	    this.vMaxX = 5; // Maximum X velocity range for snow
	    this.vMaxY = 4; // Maximum Y velocity range for snow
	    this.followMouse = true;
	    this.falling = false;
	    this.flakes = [];
	    this.setSizes();
	  }
	
	  /* HELPERS */
	
	  _createClass(Snowstorm, [{
	    key: 'start',
	    value: function start() {
	      for (var i = 0; i < this.flakesMax; i++) {
	        this.flakes[this.flakes.length] = new SnowFlake(this, random(flakeTypes));
	        if (i < meltFrameCount) meltFrames.push(1 - i / meltFrameCount);
	      }
	      this.randomizeWind();
	      this.resume();
	      this.addListeners();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      for (var i = 0; i < this.flakes.length; i++) {
	        this.flakes[i].element.parentNode.removeChild(this.flakes[i].element);
	      }
	      meltFrames = [];
	      this.flakes = [];
	      this.pause();
	      this.removeListeners();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.falling = false;
	    }
	  }, {
	    key: 'resume',
	    value: function resume() {
	      this.falling = true;
	      this.update();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      window.addEventListener('resize', this.setSizes.bind(this));
	      window.addEventListener('scroll', this.scrollHandler.bind(this));
	      window.addEventListener('blur', this.pause.bind(this));
	      window.addEventListener('focus', this.resume.bind(this));
	      this.scrollHandler();
	      if (this.followMouse) {
	        window.addEventListener('mousemove', this.mouseMove.bind(this));
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      window.removeEventListener('scroll', this.scrollHandler);
	      window.removeEventListener('resize', this.setSizes);
	      window.removeEventListener('blur', this.pause);
	      window.removeEventListener('focus', this.resume);
	      if (this.followMouse) {
	        window.removeEventListener('mousemove', this.mouseMove);
	      }
	    }
	  }, {
	    key: 'randomizeWind',
	    value: function randomizeWind() {
	      vRndX = plusMinus(random(this.vMaxX, 0.2));
	      vRndY = random(this.vMaxY, 0.2);
	      for (var i = 0; i < this.flakes.length; i++) {
	        if (this.flakes[i].active) this.flakes[i].setVelocities();
	      }
	    }
	  }, {
	    key: 'scrollHandler',
	    value: function scrollHandler() {
	      scrollY = window.scrollY || 0;
	      for (var i = 0; i < this.flakes.length; i++) {
	        if (this.flakes[i].active === 0) this.flakes[i].stick();
	      }
	    }
	  }, {
	    key: 'setSizes',
	    value: function setSizes() {
	      screenX = window.innerWidth - 16;
	      screenY = window.innerHeight;
	      docHeight = document.body.offsetHeight;
	      halfScreenX = screenX / 2;
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      if (!this.falling) return;
	      var activeFlakes = 0;
	      for (var i = 0; i < this.flakes.length; i++) {
	        if (this.flakes[i].active === 1) {
	          this.flakes[i].move();
	          activeFlakes++;
	        }
	        if (this.flakes[i].melting) this.flakes[i].melt();
	      }
	      if (activeFlakes < this.flakesMaxActive) {
	        var flake = this.flakes[parseInt(random(this.flakes.length))];
	        if (flake.active === 0) flake.melting = true;
	      }
	      window.requestAnimationFrame(this.update.bind(this));
	    }
	  }, {
	    key: 'mouseMove',
	    value: function mouseMove(e) {
	      var x = e.clientX;
	      if (x < halfScreenX) {
	        windOffset = -windMultiplier + x / halfScreenX * windMultiplier;
	      } else {
	        x -= halfScreenX;
	        windOffset = x / halfScreenX * windMultiplier;
	      }
	    }
	  }]);
	
	  return Snowstorm;
	})();
	
	exports['default'] = Snowstorm;
	function random(n, min) {
	  if (isNaN(min)) min = 0;
	  return Math.random() * n + min;
	}
	
	function plusMinus(n) {
	  return parseInt(random(2), 10) === 1 ? n * -1 : n;
	}
	module.exports = exports['default'];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background-color:#295079}", ""]);
	
	// exports


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "svg{left:0;position:absolute;top:0}line{stroke-width:2;stroke:red}.datum{left:10px}#sacuvaj{bottom:0;right:0;position:fixed}", ""]);
	
	// exports


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background-color:#000}h1{color:red}p{color:#fff}", ""]);
	
	// exports


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".izvestaj-pozadina{background-color:#ccc;background-repeat:no-repeat;background-size:cover;height:24.3em;margin:0 auto;width:39.6em}.izvestaj{padding-top:12em}.izvestaj-potpis,.izvestaj-tekst{letter-spacing:.04em;line-height:1.2;padding-left:15%;padding-right:15%}", ""]);
	
	// exports


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/komponente/izvestaj/pozadina.017c5d0aade449ea7ef9b48846498233.jpg";

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = "<style></style> <svg width=100% height=${this.svgVisina}px> ${this.putanje} </svg> ${this.scene} ${this.datumi} <button id=sacuvaj type=submit class=pozadina-belo>Sačuvaj</button> ";

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "<style></style> <h1>${this.podaci.naslov}</h1> <div> <img class=full src=${this.podaci.slika} alt=slika> </div> <p>${this.podaci.opis}</p> <div> <button value=${this.podaci.link} class=\"js-start dugme-uranja ${this.css.dugme}\">${this.podaci.akcija}</button> </div> ";

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = "<style></style> <h1>${this.podaci.naslov}</h1> <div> <img class=full src=${this.podaci.slika} alt=slika> </div> <p>${this.podaci.opis}</p> <p>${this.podaci.pitanje}</p> <div class=\"tri-dugmeta centar\"> ${this.izbori} </div> ";

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = "<style></style> <div id=izvestaj-pozadina class=izvestaj-pozadina> <div class=izvestaj> <p id=tekst class=izvestaj-tekst></p> <p id=potpis class=izvestaj-potpis></p> </div> </div> ";

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "<h1 class=naslov>${this.podaci.naslov}</h1> <div class=okvir> <img class=full src=${this.podaci.slika} alt=slika> </div> <p class=opis>${this.podaci.opis}</p> <p class=pitanje>${this.podaci.pitanje || ''}</p> <button class=kockice id=kockice><img src=/slike/kockice.gif><br> <span>${this.podaci.akcija}</span> </button> ";

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "<h1>${this.podaci.naslov}</h1> <p class=${this.css.upute}>${this.podaci.upute}</p> <input type=text id=ime> <button type=button id=pokazi-zakletvu>${this.podaci.akcija}</button> <div class=${this.css.zakletva}> <p>${this.podaci.tekstZakletve1}</p> <p>${this.podaci.tekstZakletve2}</p> <img class=full src=${this.podaci.slika}> <div class=desno> <button class=belo>${this.podaci.akcija2}</button> </div> </div> ";

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Okupacija Jugoslavije",
		"slika": "fotke/italijanska-vojska-na-balkanu.jpg",
		"opis": "Fašistički okupatori su pregazili tvoju zemlju. Regularna vojska je poražena za svega par dana. Čuo si da komunisti i neki oficiri nameravaju da nastave otpor.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Pridružiću se komunistima!",
				"link": "1941-05-15-pripreme"
			},
			{
				"opis": "Pridružiću se oficirima!",
				"link": "1941-05-15-ravna-gora"
			},
			{
				"opis": "Ostaću kod kuće.",
				"link": "1941-05-10-odvodjenje"
			}
		]
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Vratio si se doma",
		"slika": "fotke/1941/1941-10-kragujevac-nemci-odvode-narod.jpg",
		"opis": "Žandarmi u službi okupatora odvode sve za koje sumnjaju da su Romi, Jevreji ili komunisti. Zakucali su na tvoja vrata.",
		"pitanje": "Šta će biti s tobom?",
		"akcija": "Baci kockicu da saznaš.",
		"ishodi": [
			{
				"naslov": "Koncentracioni logor",
				"opis": "Zarobljen si i odveden u koncentracioni logor. Tvoji izgledi za ostanak u životu postaju sve manji."
			},
			{
				"naslov": "Izvukao si se",
				"opis": "Vojnici su ti pretresli kuću, pregledali dokumenta, i nastavili."
			},
			{
				"mrtav": "mrtav",
				"opis": "Streljan si na dnu ulice u kojoj si živeo. Tvoja smrt je potpuno uzaludna."
			}
		]
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Pripreme za ustanak",
		"slika": "fotke/1941/1941-05-komunisti-vezbaju-pucanje.jpg",
		"opis": "Sa članovima ilegalne Komunističke partije Jugoslavije izašao si van grada da vežbaš rukovanje oružjem. Ako okupaciona vlast sazna za ovo, ti i čitava tvoja porodica ćete biti internirani u koncentracione logore.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Ostaću sa partizanima!",
				"link": "1941-07-07-zakletva"
			},
			{
				"opis": "Prećiću četnicima!",
				"link": "oj-cetnici"
			},
			{
				"opis": "Vratiću se kući.",
				"link": "1941-09-24-sabac"
			}
		]
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Na Ravnoj gori",
		"slika": "fotke/1941/1941-05-ravna-gora.jpg",
		"opis": "Pridružio si se grupi nepredatih pripadnika Jugoslovenske vojske, koju predvodi pukovnik Mihailović. Za okupacionu vlast, svi koji nisu položili oružje, postaju odmetnici.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Ostaću sa četnicima",
				"link": "mmmm"
			},
			{
				"opis": "Prićiću komunistima",
				"link": "1941-07-07-zakletva"
			},
			{
				"opis": "Vratiću se kući.",
				"link": "bbbbb"
			}
		]
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Partizanska zakletva",
		"upute": "Unesi svoje ime kako bi prihvatio partizansku zakletvu:",
		"akcija": "Zaklinjem se!",
		"slika": "fotke/1941/1941-08-cacanski-partizanski-odred.jpg",
		"tekstZakletve1": "Ja ${this.igrac.ime}, sin srpskog naroda, zaklinjem se svojom čašću da u ${this.igrac.jedinica} stupam sa čvrstom odlukom da se borim protiv fašističih okupatora i izdajnika srpskog naroda.",
		"tekstZakletve2": "Mi, narodni partizani Jugoslavije, latili smo se oružja za nemilosrdnu borbu protiv krvoločnih neprijatelja koji porobiše našu zemlju i istrebljuju naše narode. Zaklinjemo se da ćemo disciplinovano, uporno i neustrašivo, ne štedeći svoje krvi i života, voditi borbu do potpunog uništenja fašističkog osvajača i svih narodnih izdajnika.",
		"akcija2": "U borbu druže ${this.igrac.ime}!"
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Nemački izveštaj",
		"tekst": "Po mišljenju komandanta Srbije, a u suprotnosti sa iznetim za Hrvatsku, nemiri se u prvom redu i gotovo isključivo imaju pripisati komunističkom uticaju.",
		"potpis": "Nemački izveštaj od 11. avgusta 1941."
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Gerilski otpor",
		"slika": "fotke/1941/1941-07-cacak-uzice-diverzija.jpg",
		"opis": "Tvoj odred je izvršio prvu uspešnu diverziju na pruzi. Izbacili ste iz šina voz koji je prevozio nemačku vojsku. Poniženi, Nemci ubijaju nejač nakon svake uspešne gerilske akcije. Tvoja porodica je ostala u gradu.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Pritajiću se u šumi.",
				"link": "pritajeni"
			},
			{
				"opis": "Napadaću još žešće fašističke krvnike.",
				"link": "borba"
			},
			{
				"opis": "Vratiću se doma.",
				"link": "1941-09-24-sabac"
			}
		]
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Čekaš da prođe rat",
		"slika": "fotke/1941/1941-09-27-sabac-odvodjenje-roma-na-streljanje",
		"opis": "Lojalan si okupatoru u svom domu. Nemci upadaju po kućama i odvode civile na streljanje. Zakucali su na tvoja vrata.",
		"pitanje": "Šta će biti s tobom?",
		"akcija": "Baci kockicu da saznaš.",
		"ishodi": [
			{
				"naslov": "Ishod 1",
				"opis": "Zarobljen si...."
			},
			{
				"naslov": "Ishod 3",
				"opis": "Izvukao si se..."
			},
			{
				"mrtav": "mrtav"
			}
		]
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Ustaničke borbe",
		"slika": "fotke/1941/1941-10-kraljevo-opsada.jpg",
		"opis": "Tvoj odred je naneo teške gubitke Nemcima u borbama za Kraljevo. Opkoljeni, okupatori masovno streljaju nedužne civile u gradu. Tvoja porodica je ostala u gradu.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Pritajiću se u šumi.",
				"link": "pritajeni"
			},
			{
				"opis": "Napadaću krvnike još žešće.",
				"link": "odmetnuti-cetnici"
			},
			{
				"opis": "Vratiću se doma.",
				"link": "kuca3"
			}
		]
	};

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Opkoljen si!",
		"slika": "fotke/nemci/nemci-pretrazuju-kolibu.jpg",
		"opis": "Krvoločni okupatori su našli kolibu u kojoj ležiš ranjen. Višestruko su nadmoćniji od tebe. Izgleda da je ovo tvoj kraj.",
		"akcija": "Otkrij svoju sudbinu!",
		"ishodi": [
			{
				"naslov": "Zarobljen si",
				"opis": "Zarobljen si i odveden u koncentracioni logor. Dok si živ još uvek ima šanse za otpor.",
				"link": "logor"
			},
			{
				"naslov": "Izvukao si se...",
				"opis": "Vojnici su pretresli kolibu ali nisu našli nikoga. Nekim čudom si uspeo da se izvučeš.",
				"link": "kuca"
			},
			{
				"mrtav": "mrtav",
				"opis": "Ubijen si na licu mesta. Tvoje kosti sada raznose zveri, ali tvoja hrabrost nadahnjuje generacije."
			}
		]
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Opkoljen si",
		"slika": "fotke/nemci/nemci-na-terenu-1943-1944.jpg",
		"opis": "Fašistički okupatori su opkolili zemunicu u kojoj se kriješ. Višestruko su nadmoćniji od tebe. Pozvan si da se predaš.",
		"pitanje": "Šta ćeš učiniti?",
		"izbori": [
			{
				"opis": "Pokušavam da bežim.",
				"link": "izbor1"
			},
			{
				"opis": "Otvaram vatru po zlikovcima!",
				"link": "izbor2"
			},
			{
				"opis": "Predajem se!",
				"link": "izbor3"
			}
		]
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = {
		"naslov": "Na straži",
		"slika": "fotke/1945/partizan_slovenija.jpg",
		"opis": "Ovo je samo proba da vidimo kako izgleda slika sa snegom."
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = {
		"1941-05-01-okupacija": {
			"x": 494,
			"y": 100
		},
		"1941-05-10-odvodjenje": {
			"x": 978,
			"y": 300
		},
		"1941-05-15-ravna-gora": {
			"x": 766,
			"y": 500
		},
		"1941-05-15-pripreme": {
			"x": 203,
			"y": 500
		},
		"1941-07-07-zakletva": {
			"x": 167,
			"y": 700
		},
		"1941-08-11-izvestaj": {
			"x": 642,
			"y": 900
		},
		"1941-09-09-diverzija": {
			"x": 212,
			"y": 1100
		},
		"1941-09-24-sabac": {
			"x": 678,
			"y": 1300
		},
		"1941-10-10-kraljevo": {
			"x": 437,
			"y": 1500
		},
		"1943-03-15-opkoljen": {
			"x": 534,
			"y": 1800
		},
		"1944-01-15-opkoljen": {
			"x": 173,
			"y": 2100
		},
		"1945-01-01-straza": {
			"x": 384,
			"y": 2400
		}
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	
	        var result = __webpack_require__(27);
	
	        if (typeof result === "string") {
	            module.exports = result;
	        } else {
	            module.exports = result.toString();
	        }
	    

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	
	        var result = __webpack_require__(28);
	
	        if (typeof result === "string") {
	            module.exports = result;
	        } else {
	            module.exports = result.toString();
	        }
	    

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	
	        var result = __webpack_require__(29);
	
	        if (typeof result === "string") {
	            module.exports = result;
	        } else {
	            module.exports = result.toString();
	        }
	    

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	
	        var result = __webpack_require__(30);
	
	        if (typeof result === "string") {
	            module.exports = result;
	        } else {
	            module.exports = result.toString();
	        }
	    

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// avantura.js